import { Stack, SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  label?: string;
  sx?: SxProps;
}

export default function VideoData_Item({
  label,
  sx,
  children,
  ...rest
}: Props) {
  return children ? (
    <Stack
      sx={{ alignItems: "center", overflow: "hidden", ...sx }}
      component="span"
      direction="row"
      {...rest}
    >
      {label && (
        <Typography
          sx={{
            mr: 1,
            color: "inherit",
            fontSize: "inherit",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          {label}:
        </Typography>
      )}
      {typeof children === "string" ? (
        <Typography
          sx={{
            color: "inherit",
            fontSize: "inherit",
            fontWeight: "inherit",
          }}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </Stack>
  ) : (
    <></>
  );
}
